import React, { useState } from "react";
import { Box, Flex } from "@edreamsodigeo/prisma-design-system";
import FindMyBookingByReferenceForm from "../FindMyBookingByReferenceForm/FindMyBookingByReferenceForm";
import FormSwitcher from "../FormSwitcher";
import GoBackArrow from "../GoBackArrow/GoBackArrow";
const LoginAndFindByBookingReferenceForms = ({
  incentivizeUserAuthentication,
  isFindBooking
}) => /*#__PURE__*/React.createElement(Box, {
  pb: "big",
  flex: "1"
}, isFindBooking ? /*#__PURE__*/React.createElement(FindMyBookingByReferenceForm, null) : incentivizeUserAuthentication);
const LoginAndFindByBookingReferenceContainer = ({
  incentivizeUserAuthentication,
  px
}) => {
  const [isFindBooking, setFindBooking] = useState(false);
  const onSwitchFormClick = () => {
    setFindBooking(!isFindBooking);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    flexDirection: "column",
    mt: {
      _: "base",
      md: "1x_big"
    },
    px: px
  }, /*#__PURE__*/React.createElement(GoBackArrow, {
    onClick: onSwitchFormClick,
    isFindBooking: isFindBooking
  }), /*#__PURE__*/React.createElement(LoginAndFindByBookingReferenceForms, {
    incentivizeUserAuthentication: incentivizeUserAuthentication,
    isFindBooking: isFindBooking
  }), /*#__PURE__*/React.createElement(FormSwitcher, {
    onClick: onSwitchFormClick,
    isFindBooking: isFindBooking
  }));
};
export default LoginAndFindByBookingReferenceContainer;